import * as React from 'react';
import { WeekdayElementProps } from 'react-day-picker';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { Typography } from '@ha/dsl';

import { DAY_COLUMN_SIZE_DESKTOP, DAY_COLUMN_SIZE_MOBILE } from '../constants';

const useStyles = makeStyles((theme: Theme) => ({
  weekDayBox: {
    color: theme.palette.text.hint,
    height: 24,
    margin: '0 2px',
    textAlign: 'center',
    width: DAY_COLUMN_SIZE_DESKTOP,

    [theme.breakpoints.down('sm')]: {
      width: DAY_COLUMN_SIZE_MOBILE,
    },
  },
}));

type OwnProps = WeekdayElementProps;

const { Caption } = Typography;

const WeekDay: React.FC<OwnProps> = props => {
  const classes = useStyles();

  const { weekday, localeUtils, locale } = props;

  return (
    <div
      className={classes.weekDayBox}
      data-test-locator="DatePicker/Calendar/WeekDay"
    >
      <Caption color="muted">
        {localeUtils.formatWeekdayShort(weekday, locale)}
      </Caption>
    </div>
  );
};

export default WeekDay;
